export default __webpack_public_path__ + "static/media/tuby.87cdcc26.webp";